import type { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import { coerceEmptyToNull } from 'utilities';
import { PressFormatForm } from './PressFormatForm';

export function PressConfigForm(): ReactElement {
  return (
    <>
      <div className="form-row">
        <TextField
          name="configuration.position"
          label="Position"
          className="col-md-6"
          help="Primary PRESS catalogue coordinate"
          {...coerceEmptyToNull}
        />
        <TextField
          name="configuration.placement"
          label="Placement"
          className="col-md-6"
          help="Optional priced qualifier"
          {...coerceEmptyToNull}
        />
        <TextField
          name="configuration.section"
          label="Section"
          className="col-md-6"
          help="Part of the book, in the vendor's wording"
          {...coerceEmptyToNull}
        />
      </div>
      <div className="col-md-10 px-0">
        <PressFormatForm name="configuration.format." required={false} />
      </div>
    </>
  );
}
